const c = {
  name: "Iot",
  dimensions: { width: 40, height: 38 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 38" style="enable-background:new 0 0 40 38;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,0c-3.3,0-6,2.7-6,6c0,3,2.2,5.4,5,5.9v4.2c-2.8,0.5-5,2.9-5,5.9c0,0.7,0.1,1.4,0.4,2.1l-3.7,2.1
			C9.5,24.9,7.9,24,6,24c-3.3,0-6,2.7-6,6s2.7,6,6,6c3.3,0,6-2.7,6-6c0-0.7-0.1-1.4-0.4-2.1l3.7-2.1c1.1,1.3,2.8,2.2,4.6,2.2
			c1.9,0,3.5-0.9,4.6-2.2l3.7,2.1C28.1,28.6,28,29.3,28,30c0,3.3,2.7,6,6,6c3.3,0,6-2.7,6-6s-2.7-6-6-6c-1.9,0-3.5,0.9-4.6,2.2
			l-3.7-2.1c0.2-0.6,0.4-1.3,0.4-2.1c0-3-2.2-5.4-5-5.9v-4.2c2.8-0.5,5-2.9,5-5.9C26,2.7,23.3,0,20,0z M16,6c0-2.2,1.8-4,4-4
			c2.2,0,4,1.8,4,4c0,2.2-1.8,4-4,4C17.8,10,16,8.2,16,6z M2,30c0-2.2,1.8-4,4-4s4,1.8,4,4c0,2.2-1.8,4-4,4S2,32.2,2,30z M20,18
			c2.2,0,4,1.8,4,4c0,2.2-1.8,4-4,4c-2.2,0-4-1.8-4-4C16,19.8,17.8,18,20,18z M34,26c2.2,0,4,1.8,4,4c0,2.2-1.8,4-4,4
			c-2.2,0-4-1.8-4-4C30,27.8,31.8,26,34,26z"/>
		<path class="st0" d="M11,22c0-3.3,1.8-6.3,4.5-7.8l-1-1.7C11.2,14.3,9,17.9,9,22H11z"/>
		<path class="st0" d="M25.4,12.4c3.3,1.9,5.6,5.5,5.6,9.6h-2c0-3.3-1.8-6.3-4.5-7.8L25.4,12.4z"/>
		<path class="st0" d="M14.4,31.4c1.6,1,3.6,1.6,5.6,1.6c2.1,0,4-0.6,5.6-1.6l-1-1.7C23.3,30.5,21.7,31,20,31
			c-1.7,0-3.3-0.5-4.6-1.3L14.4,31.4z"/>
		<path class="st0" d="M4,22c0-6,3.3-11.1,8.1-13.9l1,1.7C8.8,12.3,6,16.8,6,22v0.1L4,22L4,22z"/>
		<path class="st0" d="M26.9,9.8c4.2,2.4,7.1,7,7.1,12.2v0.1h2V22c0-6-3.3-11.1-8.1-13.9L26.9,9.8z"/>
		<path class="st0" d="M20,38c-3,0-5.8-0.8-8.2-2.3l1-1.7c2.1,1.2,4.5,2,7.2,2c2.6,0,5.1-0.7,7.2-2l1,1.7C25.8,37.2,23,38,20,38z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Iot
};
